import type { FaireProductEntity } from "../../entity_types/product";

export const p_2vga8kr6n3: FaireProductEntity = {
  token: "p_2vga8kr6n3",
  type: "product",
  name: "Manhattan - 12oz - Whole Bean Coffee",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl:
    "https://cdn.faire.com/fastly/bb1d8dece650e2ddfb8f593c54709a0626be17a32d3ae898786ef11609a45e85.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/89f02222b3c310ad5a648f3f6472b4c8154f4cf7d0dbe5ac2771d4f03b3cbc29.jpeg",
    "https://cdn.faire.com/fastly/1eb928ef14f676ce4acfab071fd5d1bee556f2695f2d251f3d34efa64c66a43a.jpeg",
    "https://cdn.faire.com/fastly/a61b607e0c6480832493a61b25406e9f1b418c7aff842f79d2de0bff6e07ad9d.jpeg",
    "https://cdn.faire.com/fastly/1a9a4c363ca2e45e0dfd5c33a23251e2cd84491ee9f462e1668e4d9d0f09962a.jpeg",
  ],
  priceDollars: 10.92,
  description:
    "Our most developed, deepest roast, the Manhattan Blend is full-bodied and rich, with dark chocolate notes, marzipan and the syrupy sweetness of molasses.\n\n𝐂𝐨𝐟𝐟𝐞𝐞 𝐈𝐧𝐟𝐨\n• Producer Luiz Pedro Pereira and Josue Morales\n• Tasting Notes Baker’s Chocolate, Caramel, Maple Syrup\n• Elevation 1,100 - 1,900 meters\n• Region Carmo de Minas, Brazil and Santa Rosa, Guatemala\n• Variety Various\n• Process Dry and Wet-Processed\n\n𝐅𝐚𝐫𝐦 𝐑𝐞𝐥𝐚𝐭𝐢𝐨𝐧𝐬𝐡𝐢𝐩\n• Yes\n\nPerfect For: Father's Day gifting",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:07.141Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
